export default __webpack_public_path__ + "static/media/circle-orange.7a2cf605.svg";